const checkConditionsRequired = (field) => {
  if (!field?.conditions?.length) return false

  return field.conditions.some((condition) => {
    try {
      const thenBranch = condition.fn(['__truthy__'], field)
      const otherwiseBranch = condition.fn([null], field)

      const thenRequired =
        thenBranch?.describe?.()?.tests?.some((test) => test.name === 'required') ?? false
      const otherwiseRequired =
        otherwiseBranch?.describe?.()?.tests?.some((test) => test.name === 'required') ?? false

      return thenRequired || otherwiseRequired
    } catch {
      return false
    }
  })
}

const resolveLazyField = (field) => {
  try {
    const resolved = field.resolve({ value: '' })
    return resolved?.describe?.() ?? null
  } catch {
    return null
  }
}

const extractRequiredFields = (schema, prefix = '') => {
  const result = {}

  try {
    const described = schema.describe()

    if (described.type === 'object' && described.fields) {
      Object.entries(described.fields).forEach(([key, fieldDesc]) => {
        const path = prefix ? `${prefix}.${key}` : key

        let effectiveDesc = fieldDesc

        if (fieldDesc.type === 'lazy' && schema.fields?.[key]) {
          const resolved = resolveLazyField(schema.fields[key])
          if (resolved) {
            effectiveDesc = resolved
          }
        }

        if (effectiveDesc.type === 'object' && effectiveDesc.fields) {
          Object.assign(result, extractRequiredFields(schema.fields[key], path))
        } else {
          const isRequired =
            effectiveDesc.optional === false ||
            (effectiveDesc.tests?.some((test) => test.name === 'required') ?? false)

          if (isRequired) {
            result[path] = true
          } else if (schema.fields?.[key]?.conditions?.length) {
            if (checkConditionsRequired(schema.fields[key])) {
              result[path] = true
            }
          }
        }
      })
    }
  } catch {
    // noop
  }

  return result
}

export default extractRequiredFields
